import { Box, Heading, VStack } from '@chakra-ui/react'
import React from 'react'
import ButtonSelectorList from '../../components/ButtonSelectorList/ButtonSelectorList'
import UnderlineHeading from '../../components/UnderlineText/UnderlineHeading'
import useButtonSelector from '../../utils/hooks/useButtonSelector/useButtonSelector'
import { colors } from '../../utils/theme/styles'
import SubViewFactory, { SubViewFactoryLabels } from './subViews/SubViewFactory'
const options = [
  {
    label: 'SUCURSALES',
    color: colors.primary.base,
    view: SubViewFactoryLabels.branch,
  },
  {
    label: 'CENTRO DE COSTO',
    color: colors.primary.base,
    view: SubViewFactoryLabels.costCenter,
  },
]

export default function BranchAndCostCenter() {
  const { selected, onSelectedChange } = useButtonSelector(options)
  return (
    <VStack w="100%" alignItems="flex-start" mb="100px" spacing="24px">
      <UnderlineHeading
        text="Centro de costo y sucursales"
        variant="h5"
        color={colors.gray[800]}
      />
      <Heading color={'#000000'} variant="h5">
        Elige una opción
      </Heading>
      <Box h="56px">
        <ButtonSelectorList
          options={options}
          buttonVariant={'gray'}
          selected={selected}
          onSelectedChange={onSelectedChange}
          stackProps={{ h: '100%' }}
        />
      </Box>
      <Box w="100%">
        <SubViewFactory view={selected.view} />
      </Box>
    </VStack>
  )
}
